import Icon from 'Components/Icon';
import React from 'react';

const Circle = props => <Icon color={props.color} icon={['fas', 'circle']} size={props.size || 'xs'} {...props}/>;

export default Circle;
